var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutimg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249.522,
    height: 249.526,
    viewBox: "0 0 249.522 249.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "DSC_9556",
    d: "M249.176,108.205c.405,9.015.468,23.8.125,32.845a138.448,138.448,0,0,1-5.958,32.377,117.08,117.08,0,0,1-15.861,29.321,91.6,91.6,0,0,1-25.671,21.008c-8.328,4.211-21.834,10.668-30.116,14.333a160.046,160.046,0,0,1-31.348,9.482,171.008,171.008,0,0,1-33.188,1.794A72.209,72.209,0,0,1,76.45,238.791c-7.626-5.225-19.963-13.459-27.418-18.294A205.166,205.166,0,0,1,23.47,200.128,68.389,68.389,0,0,1,7.5,172.461c-2.2-8.843-5.006-23.223-6.238-31.972a174.022,174.022,0,0,1-.9-32.019A145.853,145.853,0,0,1,7.328,76.92,125.61,125.61,0,0,1,23.174,48.441,89.334,89.334,0,0,1,48.127,27.854,213.858,213.858,0,0,0,76.4,9.825,54.118,54.118,0,0,1,106.971,0a300.755,300.755,0,0,1,33.142,3.665c8.843,1.56,23.566,4.351,32.752,6.16A70.65,70.65,0,0,1,201.873,24.5a135.2,135.2,0,0,1,20.618,25.406c4.554,7.8,12.258,20.275,17.156,27.964a73.207,73.207,0,0,1,9.56,30.319",
    transform: "translate(-0.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutimg02);
export default __webpack_public_path__ + "static/media/aboutimg02.a2618f70e7ff21e39bcb57d26eeb54d6.svg";
export { ForwardRef as ReactComponent };